import { bindActionCreators } from '@reduxjs/toolkit';
import Icon from 'carbon-react/lib/components/icon';
import Portrait from 'carbon-react/lib/components/portrait';
import Menu, { Divider, Item as MenuItem } from 'rc-menu';
import { useCallback, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Popover } from 'react-tiny-popover';
import packageInfo from '../../../package.json';
import SageLogo from '../../assets/img/sage_logo.png';
import Notifications from '../../components/Notifications';
import Translate from '../../components/Translate/Translate';
import { config } from '../../config/env';
import * as GeneralActions from '../../redux/General/actions';
import { selectGeneralShowApprovalsTab, selectIsAuthenticated, selectToken, selectUserData } from '../../redux/selectors';
import * as UserActions from '../../redux/User/actions';
import UnsupportedBrowser from '../../components/UnsupportedBrowser/UnsupportedBrowser';

const DashboardContainer = ({
  children,
  getApprovalsCheck,
  history,
  isAuthenticated,
  location,
  logout,
  showApprovalsTab,
  showSecondaryNav,
  token,
  userData,
}) => {
  const [profileOpen, setProfileOpen] = useState(false);
  const isActive = (url) => {
    if (location.pathname.indexOf(url) > -1) return 'active';
    return '';
  };

  const navigate = (url) => {
    if (isAuthenticated) {
      getApprovalsCheck();
    }
    history.push(url);
  };

  const menu = isAuthenticated ? (
    <Menu>
      <MenuItem disabled className="submenu-item logged-in-as" key="loggedin">
        <Translate scope="navigation.Loggedinas" />
        <div className="username">{userData?.username}</div>
        <div className="company">{userData?.company?.intacctCompanyId}</div>
      </MenuItem>
      <Divider />
      <MenuItem className="submenu-item" key="settings" onClick={() => navigate('/settings')}>
        <Icon type="settings" />
        <Translate scope="navigation.Settings" />
      </MenuItem>
      <Divider />
      <MenuItem className="submenu-item" key="logout" onClick={() => logout({ token })}>
        <Icon type="logout" />
        <Translate scope="navigation.Logout" />
      </MenuItem>
    </Menu>
  ) : (
    <Menu>
      <MenuItem className="submenu-item" key="login" onClick={() => navigate('/login')}>
        <Icon type="logout" />
        <Translate scope="navigation.LogIn" />
      </MenuItem>
    </Menu>
  );

  return (
    <div className="dashboard">
      <div className="navigation-bars">
        <div className="navigation">
          <div className="left-content">
            <img src={SageLogo} alt="logo" className="logo" />
            <div className="divider"></div>
            <div className="title"> Intelligent Time</div>
          </div>
          <div className="right-content">
            {isAuthenticated && (
              <>
                <Notifications />
                <div className="icon-button" onClick={() => window.open(process.env.REACT_APP_HELP_URL, '_blank')}>
                  <Icon tooltipAlign="center" tooltipMessage="Help" tooltipPosition="bottom" type="help" />
                </div>
              </>
            )}
            <Popover
              align={'end'}
              containerClassName="profile-popover"
              content={menu}
              isOpen={profileOpen}
              onClickOutside={() => setProfileOpen(false)}
              overlayClassName="profile-dropdown"
              padding={0}
              positions={['bottom']}
            >
              <div className="icon-button profile" onClick={() => setProfileOpen(!profileOpen)}>
                <Portrait size="XS" shape="square" />
              </div>
            </Popover>
          </div>
        </div>
        {showSecondaryNav && isAuthenticated && (
          <div className="secondary-navigation">
            <div className={`nav-link ${isActive('timesheets')}`} onClick={() => navigate('/timesheets')}>
              <Translate scope="navigation.Timesheets" />
            </div>
            {showApprovalsTab && (
              <div className={`nav-link ${isActive('approvals')}`} onClick={() => navigate('/approvals')}>
                <Translate scope="navigation.Approvals" />
              </div>
            )}
            <div className={`nav-link ${isActive('data-sources')}`} onClick={() => navigate('/data-sources')}>
              <Translate scope="navigation.DataSources" />
            </div>
            {!config.isProduction && <span className="version-debug">{`package version ${packageInfo.version}`}</span>}
          </div>
        )}
      </div>
      <div className={`content ${showSecondaryNav && isAuthenticated ? 'with-secondary-nav' : ''}`}>{children}</div>
      <div className="page-footer">
        {/* eslint-disable-next-line react-hooks/exhaustive-deps */}
        <div className="link" onClick={useCallback(() => navigate('/privacy'), [])}>
          <Translate scope="navigation.Privacy" />
        </div>
        <div
          className="link"
          onClick={useCallback(
            () =>
              window.open(
                'https://public-assets-dev-c8ha462swai.s3-us-west-1.amazonaws.com/licenses/web/third-party-licenses.html',
                '_blank'
              ),
            []
          )}
        >
          <Translate scope="navigation.Thirdpartylicences" />
        </div>
      </div>
      <UnsupportedBrowser />
    </div>
  );
};

const mapStateToProps = (state) => ({
  isAuthenticated: selectIsAuthenticated(state),
  showApprovalsTab: selectGeneralShowApprovalsTab(state),
  token: selectToken(state),
  userData: selectUserData(state),
});

const mapDispatchToProps = (dispatch) => {
  const _general = bindActionCreators(GeneralActions, dispatch);
  const _user = bindActionCreators(UserActions, dispatch);
  return {
    getApprovalsCheck: _general.getApprovalsCheckRequest,
    logout: _user.logoutRequest,
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DashboardContainer));
